import { Card, Service } from '@yleisradio/areena-types';
import classNames from 'classnames';
import Image from 'next/image';
import React from 'react';
import { defaultLoader, loaderUrl } from 'utils/cloudinary';
import { Link } from 'components/Link';
import styles from './SearchSuggestion.module.scss';

interface SearchSuggestionProps {
  card: Card;
  service: Service;
  isSelected: boolean;
}

export const SearchSuggestion: React.FunctionComponent<
  SearchSuggestionProps
> = ({ card, isSelected, service }) => {
  if (!card.pointer) {
    return null;
  }

  const imageSrc = card.image || { id: '', version: '' };

  const classes = classNames(
    styles.search__suggestion,
    isSelected && styles.selected
  );

  return (
    <Link pointer={card.pointer} service={service} className={classes}>
      <span className={styles.search__suggestion__textcontent}>
        <span className={styles.search__suggestion__textcontent__title}>
          {card.title}
        </span>
        <span className={styles.search__suggestion__textcontent__subtitle}>
          {card.description}
        </span>
      </span>
      <div className={styles.search__suggestion__image}>
        <Image
          aria-label={card.title}
          alt={card.title || ''}
          loader={defaultLoader}
          src={loaderUrl(imageSrc)}
          width={65}
          height={65}
          priority
          style={{ objectFit: 'cover' }}
        />
      </div>
    </Link>
  );
};
